import React from 'react';
import { ButtonMinorAction } from '../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { TopContentResult } from '../../../components/molecules/Form/components/ComboBox';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { PrivilegedGroupParam } from './PrivilegedGroupsAddForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FormsComboboxMultiSelectListElement } from '../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectListElement';
import { FormsComboboxMultiselectSelection } from '../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiselectSelection';
import { StateFacetItem } from '../../../components/molecules/ResultListSettings/ResultListSettings';
import SelectALot from '../../../components/molecules/Form/components/SelectALot/SelectALot';

type PrivilegedGroupsMultiSelectListItemProps = {
  selectedResult: TopContentResult;
  removeResult: (item: TopContentResult) => void;
  grantedRolesParam: PrivilegedGroupParam<'grantedRoles'>;
  groupIndex: number;
};

export function PrivilegedGroupsMultiSelectListItem({
  selectedResult,
  removeResult,
  grantedRolesParam,
  groupIndex,
}: PrivilegedGroupsMultiSelectListItemProps) {
  const id = useHtmlValidId();
  const { t } = useSonTranslation('FormsComboBoxMultiSelect');

  return (
    <>
      <FormsComboboxMultiSelectListElement>
        <FormsComboboxMultiselectSelection id={`recipient-${id}-${selectedResult.id}`} title={selectedResult.title}>
          <SelectALot
            title={t('glossary:role_plural')}
            name={`privilegedGroups[${groupIndex}].grantedRoles`}
            items={grantedRolesParam.options as StateFacetItem[]}
          />
          <ButtonMinorAction
            icon={Icons.DELETE_X_SMALL}
            text={t('resultlist.deleteButtonText', { itemName: selectedResult.title })}
            onClick={() => {
              removeResult(selectedResult);
            }}
            tooltipPlacement={TooltipPlacement.TOP}
          />
        </FormsComboboxMultiselectSelection>
      </FormsComboboxMultiSelectListElement>
      <input type="hidden" name={`privilegedGroups[${groupIndex}].groupId`} value={selectedResult.id} />
    </>
  );
}
